<span class="info-message">
  <div class="row">
    <div class="col-1 m-auto">
      <mat-icon class="info-icon">{{ icon }}</mat-icon>
    </div>
    <div class="col-11 m-auto">{{ text }}</div>
  </div></span
>
